<div class="dialog-map-selector dialog">

    <div mat-dialog-title>
        Selectionner votre position sur la carte
    </div>

    <mat-dialog-content class="d-flex flex-row">
        <div class="col col-md-6 col-12">
            <h2>Les informations sélectionnées</h2>
        </div>

        <div class="map-container col col-md-6 col-12">
            <div class="map-frame">
                <div id="map"></div>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="d-flex flex-row justify-content-end">
        <button class="btn btn-light" mat-dialog-close>Annuler</button>
        <button class="btn btn-success" (click)="dialogRef.close(coordinates)">Valider la position</button>
    </mat-dialog-actions>


</div>